import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  duration,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import phone from "../../../redux/slices/phone";
import {
  EmojiEmotions,
  AccountCircle,
  Bolt,
  Phone,
  Badge,
  DialerSip,
} from "@mui/icons-material";
import { secondToHHMMSS } from "../../../helpers/datetime-helper";
import app from "../../../redux/slices/app";
import { logout } from "../../../redux/slices/user";

interface UserMenuProps {
  user: any;
  phone: any;
  duration: number;
  onPhoneButtonClicked: Function;
  onSIPAccountButtonClicked: Function;
  onLoginButtonClicked: Function;
  onChangePasswordButtonClicked: Function;
  onLogoutButtonClicked: Function;
}
export default function UserMenu({
  user = undefined,
  phone = undefined,
  duration = 0,
  onPhoneButtonClicked = () => {},
  onSIPAccountButtonClicked = () => {},
  onLoginButtonClicked = () => {},
  onChangePasswordButtonClicked = () => {},
  onLogoutButtonClicked = () => {},
}: UserMenuProps) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const handleOpenUserMenu = (event: any) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  let component = (
    <Button size="large" color="inherit" onClick={() => onLoginButtonClicked()}>
      Đăng nhập
    </Button>
  );
  if (user?.isLoggedin) {
    component = (
      <>
        {user?.roles.indexOf("org.customer") >= 0 ? (
          <Button variant="text" startIcon={<Bolt />} color="inherit">
            <Typography>0</Typography>
          </Button>
        ) : (
          <React.Fragment />
        )}
        {user?.roles.indexOf("org.agent") >= 0 ? (
          <Button
            variant="text"
            color={
              phone?.SIPAccount.status === "offline" ? "warning" : "inherit"
            }
            startIcon={<Phone />}
            onClick={() => {
              onPhoneButtonClicked();
            }}
          >
            <Typography
              display={phone?.call.direction ? "inline-flex" : "none"}
            >
              {phone?.call.direction === "inbound"
                ? phone?.call.fromNumber
                : phone?.call.toNumber}
              {phone?.contact.fullname ? ` - ${phone?.contact.fullname}` : ""} -{" "}
              {secondToHHMMSS(duration)}
            </Typography>
          </Button>
        ) : (
          <React.Fragment />
        )}
        {user?.roles.indexOf("org.sale") >= 0 ? (
          <Button variant="text" startIcon={<EmojiEmotions />} color="inherit">
            <Typography>0588</Typography>
          </Button>
        ) : (
          <React.Fragment />
        )}
        {/*  <IconButton title={"Thông báo"} color="inherit">
    <Badge badgeContent={2} color="secondary">
      <NotificationsIcon fontSize="inherit" />
    </Badge>
  </IconButton> */}
        <Button
          variant="text"
          color="inherit"
          onClick={handleOpenUserMenu}
          startIcon={<AccountCircle />}
        >
          {user?.username}
        </Button>
        <Menu
          id="user-menu"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem
            title="Mã nhân viên"
            sx={{ display: user?.staffCode ? "flex" : "none" }}
          >
            <ListItemIcon>
              <Badge fontSize="small" />
            </ListItemIcon>
            <ListItemText>{user?.staffCode}</ListItemText>
          </MenuItem>
          <MenuItem
            title="Tài khoản gọi"
            sx={{
              display: phone?.SIPAccount.name ? "flex" : "none",
              color: phone?.SIPAccount.status === "offline" ? "gray" : "green",
            }}
            onClick={() => {
              onSIPAccountButtonClicked();
            }}
          >
            <ListItemIcon>
              <DialerSip
                fontSize="small"
                sx={{
                  color:
                    phone?.SIPAccount.status === "offline" ? "gray" : "green",
                }}
              />
            </ListItemIcon>
            <ListItemText>{phone?.SIPAccount.name}</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              onChangePasswordButtonClicked();
            }}
          >
            Đổi mật khẩu
          </MenuItem>
          <MenuItem
            onClick={() => {
              onLogoutButtonClicked();
            }}
          >
            Đăng xuất
          </MenuItem>
        </Menu>
      </>
    );
  }
  return component;
}
